// Release API
// export const H_BASE_URL = "https://ha.digitastic.app"
// export const T_BASE_URL = "https://dailyreportapi.digitastic.app/api/";
// export const IMG_BASE_URL = "https://imageupdate.digitastic.app/profilImage/";
// export const O_BASE_URL = "https://drivesearchapi.digitastic.app/api";


export const T_BASE_URL = "https://dailyreportapi.digitastic.app/api/";
export const INTERNAL_API_BASE_URL = "https://ia.digitastic.app";
export const HELPER_API_BASE_URL = "https://ha.digitastic.app";
export const OAUTH_LOGIN_API_BASE_URL = "https://ra.digitastic.app/api";
export const IMAGE_BASE_URL = "https://imageupdate.digitastic.app/profilImage/";




// export const INTERNAL_API_BASE_URL = "https://internalapi.digitastic.app";
// export const HELPER_API_BASE_URL = "https://helperapi.digitastic.app";
// export const OAUTH_LOGIN_API_BASE_URL = "https://ra.digitastic.app/api";
// export const IMAGE_BASE_URL = "https://imagetest.digitastic.app";




// Test API
// export const H_BASE_URL = "https://helperapi.digitastic.app"
// export const IMG_BASE_URL = "https://imagetest.digitastic.app/profilImage/";
// export const O_BASE_URL = "https://drivesearchapitest.digitastic.app/api"


// export const T_BASE_URL = "http://192.168.6.13:3065/api/";

// export const OAUTH_LOGIN_API_BASE_URL = "https://drivesearchapitest.digitastic.app/api";
// export const VERIFY_API_BASE_URL = "https://verifyapitest.digitastic.app/api";


export const M_BASE_URL = 'https://ma.digitastic.app'
export const L_BASE_URL = 'https://my.digitastic.app'